// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_QF1zzoMDa",
    "aws_user_pools_web_client_id": "4q7pc7ggmjuqgr541079e8ho9",
    "oauth": {}
};


export default awsmobile;
